/**
 * @generated SignedSource<<69e49df0c12b9cbc66fe174ad321c266>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: string | null | undefined;
  patch: UserPatch;
  rowId: any;
};
export type UserPatch = {
  firstName?: string | null | undefined;
  isEmailMarketingEnabled?: boolean | null | undefined;
  isEmailNotificationsEnabled?: boolean | null | undefined;
  isMetricSystem?: boolean | null | undefined;
  lastName?: string | null | undefined;
  offerCodes?: ReadonlyArray<string | null | undefined> | null | undefined;
  rowId?: any | null | undefined;
  scheduledDeletionAt?: any | null | undefined;
};
export type useSetUserIsMetricSystemMutation$variables = {
  input: UpdateUserInput;
};
export type useSetUserIsMetricSystemMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly isMetricSystem: boolean | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserIsMetricSystemMutation = {
  response: useSetUserIsMetricSystemMutation$data;
  variables: useSetUserIsMetricSystemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMetricSystem",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserIsMetricSystemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserIsMetricSystemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c5b211b28d707df08f370ee38feca92",
    "id": null,
    "metadata": {},
    "name": "useSetUserIsMetricSystemMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserIsMetricSystemMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      isMetricSystem\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36dd889529094efc1ed4f3ec1678c774";

export default node;
